import { ColumnListDto } from '@common/dto/column/list-dto';
import { ColumnSaveDto } from '@common/dto/column/save-dto';
import { IndividualListSex } from '@common/dto/individual/individual-list-sex';
import { HttpSuccessDto } from '@common/dto/http';
import { IndividualListDto } from '@common/dto/individual/list-dto';
import { UserMaintenanceProfile } from '@common/dto/user-maintenance/profile';
import { clientTransformed } from '@common/utils/rest';
import { PedigreeListDto } from '@common/dto/pedigree/list-dto';

const getUrl = (path: string) => {
  return `api/pedigree/members/${path}`;
};

export const getIndividualsColumns = (): Promise<Array<ColumnListDto>> => {
	return clientTransformed({
    path: getUrl('columns'),
    method: 'GET'
  }).then(
    (response: HttpSuccessDto<Array<ColumnListDto>>) => {
      return response.entity;
    },
  );
};

export const saveIndividualsColumns = (columns: Array<ColumnSaveDto>) => {
	return clientTransformed({
    path: getUrl('columns'),
    method: 'POST',
		entity: {
      columns
    },
  });
};

export type GetIndividualsRequestFiltering = {
  filterApplied: boolean;
  columnFilters: {};
  columns: Array<ColumnListDto>,
  pedigreeId: PedigreeListDto['id'],
};

export type GetIndividualsRequestPagination = {
  start: number;
  size: number;
};

export type GetIndividualsRequestParams = {
  filtering: GetIndividualsRequestFiltering;
  pagination: GetIndividualsRequestPagination;
};

export const getIndividuals = ({ filtering, pagination }: GetIndividualsRequestParams): Promise<{ data: Array<IndividualListDto>; totalCount: number; }> => {
	return clientTransformed({
    path: getUrl('smartlist'),
    method: 'POST',
		entity: {
			...filtering,
			...pagination,
		},
  }).then(
    (response: HttpSuccessDto<{ data: Array<IndividualListDto>; totalCount: number; }>) => {
      return response.entity;
    },
  );
};


export const applyIndividualsCurrentColumnsToAllUsers = (columns: Array<ColumnListDto>) => {
	return clientTransformed({
    path: getUrl('columns'),
    method: 'POST',
		entity: {
      columns,
      action: "APPLY_ALL"
    },
  });
};

export const applyIndividualsCurrentColumnsToSpecificUsers = (columns: Array<ColumnListDto>, profilesFormat: Array<UserMaintenanceProfile['name']>) => {
	return clientTransformed({
    path: getUrl('columns'),
    method: 'POST',
		entity: {
      columns,
      profiles: profilesFormat,
      action: "APPLY_PROFILES"
    },
  });
};

export const setIndividualsDefaultColumnsForToAllUsers = (columns: Array<ColumnListDto>) => {
	return clientTransformed({
    path: getUrl('columns'),
    method: 'POST',
		entity: {
      columns,
      action: "DEFAULT_ALL"
    },
  });
};

export const setIndividualsDefaultColumnsForSpecificUsers = (columns: Array<ColumnListDto>, profilesFormat: Array<UserMaintenanceProfile['name']>) => {
	return clientTransformed({
    path: getUrl('columns'),
    method: 'POST',
		entity: {
      columns,
      profiles: profilesFormat,
      action: "DEFAULT_PROFILES"
    },
  });
};

export const restoreIndividualsColumnsToDefault = () => {
	return clientTransformed({
    path: getUrl('columns'),
    method: 'GET',
    params: {
      default: true
    },
  }).then(
    (response: HttpSuccessDto<Array<ColumnListDto>>) => {
      return response.entity;
    },
  );
};

export type ChangeSexParams = {
  globalId: IndividualListDto['id'];
  newGender: IndividualListSex;
}

export const changeSex = (params: ChangeSexParams) => {
  return clientTransformed({
    path: 'api/individuals/changeGender',
    method: 'POST',
    params
  });
}